export default __webpack_public_path__ + "static/media/jasperactive-DL-logo.df7779f1.svg";